import React, { useEffect, useRef } from "react";
import { Col, Container, Row } from "reactstrap";

export default function Photos() {
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;
  const swiperRef = useRef(null);
  const swiperInstanceRef = useRef(null);

  useEffect(() => {
    // Wait for Swiper to be available globally
    if (typeof window !== "undefined" && window.Swiper && swiperRef.current && !swiperInstanceRef.current) {
      swiperInstanceRef.current = new window.Swiper(swiperRef.current, {
        initialSlide: 2,
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
      });
    }

    // Cleanup
    return () => {
      if (swiperInstanceRef.current) {
        swiperInstanceRef.current.destroy(true, true);
        swiperInstanceRef.current = null;
      }
    };
  }, []);

  return (
    <>
      <div
        style={{
          backgroundColor: "#000",
        }}
        className="section section-with-space"
        data-parallax={true}
      >
        <Container>
          <Row>
            <Col lg={12}>
              <div
                ref={swiperRef}
                className="swiper mySwiper"
                style={{
                  padding: size ? "3rem 0" : "2rem 0",
                }}
              >
                <div className="swiper-wrapper">
                  {images.map((i) => (
                    <div
                      key={i}
                      className="swiper-slide"
                      style={{
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        width: size ? "50%" : "80%",
                        height: "100%",
                      }}
                    >
                      <img
                        src={require(`assets/photos/${i}`)}
                        width="100%"
                        alt="Saifee"
                        style={{
                          borderRadius: "12px",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

const images = [
  "01.jpg",
  "02.jpg",
  "03.jpg",
  "04.jpg",
  "05.jpg",
  "06.jpg",
  "07.jpg",
  "08.jpg",
  "09.jpg",
  "010.jpg",
  "011.jpg",
  "012.jpg",
  "013.jpg",
  "014.jpg",
  "015.jpg",
  "016.jpg",
  "017.jpg",
  "018.jpg",
  "019.jpg",
  "020.jpg",
  "021.jpg",
  "022.jpg",
  "023.jpg",
  "024.jpg",
  "025.jpg",
  "026.jpg",
  "027.jpg",
  "028.jpg",
  "029.jpg",
  "029.jpg",
];
